module.exports = __webpack_public_path__ + "img/hand-insanon.e8a62dd9.png";